import type { RegistrationStatus } from "@/modules/events/types/eventDetailsApi"
import type { FunctionComponent } from "react"

import { useParams } from "next/navigation"

import { Button } from "@jobteaser/spark/components/Button"

import { useEventDetailsData } from "@/modules/events/hooks/useEventDetailsData"
import { getConferenceUrlToDisplay, getIsLinkDisplayed } from "@/modules/events/utils/videoConferenceLink"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

type AccessButtonProps = {
  registrationStatus: RegistrationStatus
}

export const AccessButton: FunctionComponent<AccessButtonProps> = ({ registrationStatus }) => {
  const { t } = useTranslation(["event_details"])
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const event = useEventDetailsData(eventSlug)

  if (!event || new Date(event.endDate) < new Date()) {
    return null
  }

  const conferenceUrlToDisplay = getConferenceUrlToDisplay({ event, registrationStatus })
  const isLinkDisplayed = getIsLinkDisplayed({ conferenceUrl: conferenceUrlToDisplay, startDate: event.startDate })

  if (isLinkDisplayed) {
    return (
      <Button
        renderComponent="a"
        href={conferenceUrlToDisplay}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="event-details-registration-details-join-button"
      >
        {t("event_details.join")}
      </Button>
    )
  }

  return (
    <Button disabled data-testid="event-details-registration-details-join-button">
      {t("event_details.join")}
    </Button>
  )
}
